import React, { useRef, useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Button from "../../Elements/Button/Button.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import CustomPopup from "components/Pages/Inbox/Popups/CustomPopup.js";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { useMail } from "contexts/mailContext/mailContext.js";

import "./MessageBox.scss";

const MessageBox = ({
  textKey,
  replaceText,
  icon,
  allowClosing,
  backgroundColor,
}) => {
  const { mobileCondition } = useMediaQueries();
  const { getMailMetaData } = useMail();

  const { getTextByKey, getHtmlByKey } = useContent();
  const [isRemoved, setIsRemoved] = useState(false);

  const [showLog, setShowLog] = useState(false);

  const handleClick = () => {
    setIsRemoved(true);
  };
  const textToShow = () => {
    if (replaceText) {
      return getHtmlByKey(textKey).replace(/#(.*)#/, replaceText.toUpperCase());
    } else {
      return getHtmlByKey(textKey);
    }
  };

  const handleShowLog = () => {
    setShowLog((prev) => !prev);
  };

  const logRef = useRef();

  useOnClickOutside(logRef, () => setShowLog(false));

  return (
    <AnimationContainer animationOn={!isRemoved} animationClassName="fade-in">
      <div className="message-box-container">
        <div className={`message-box-message-container ${icon.color}`}>
          <div className={`message-box-colored-side ${icon.color}`}> </div>
          <div
            className={`message-box-message-inner-container ${
              backgroundColor ? backgroundColor : ""
            }`}
          >
            <div className="flex-grow">
              {icon ? (
                <Icon
                  name={icon.name}
                  red={icon.color === "red"}
                  white={icon.color === "white"}
                  gray={icon.color === "gray"}
                  blue={icon.color === "blue"}
                  orange={icon.color === "orange"}
                  xxxl={!mobileCondition}
                  xxl={mobileCondition}
                />
              ) : null}
            </div>
            <div className="message-box-message-text">
              {textToShow()}
              {getMailMetaData().errorFilesList ? (
                <div className="error-files-log">
                  {getTextByKey("sidebar-info-missing-files")}:{" "}
                  <span onClick={handleShowLog} ref={logRef}>
                    {getTextByKey("upload-complete-show")}
                    <CustomPopup showState={showLog} topPosition={25}>
                      <div className="full-recipents-list">
                        <div className="right-side">
                          {getMailMetaData().errorFilesList?.map((item, i) => {
                            const size = bytesToDisplayHelper(item.size);
                            return (
                              <div className="mail-adress" key={item.name}>
                                {item.name} ({size.size + size.type})
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </CustomPopup>
                  </span>
                </div>
              ) : null}
            </div>
            {allowClosing ? (
              <Button close onClick={handleClick}>
                <Icon small name="x"></Icon>
              </Button>
            ) : null}
            <div className="flex-grow"></div>
          </div>
        </div>
      </div>
    </AnimationContainer>
  );
};

export default MessageBox;
